import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Clock, LogOut, Mail } from 'lucide-react';

export default function PendingApprovalPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-6" data-testid="pending-approval-page">
      <div className="max-w-lg w-full text-center">
        <div className="border border-[#A0743A]/30 p-12 bg-[#1A1A1A]">
          <Clock size={48} className="text-[#A0743A] mx-auto mb-8" strokeWidth={1.25} />

          <h1 className="text-3xl text-[#FAF8F5] mb-4" style={{ fontFamily: "'Cormorant Garamond', Cambria, Georgia, serif" }}>
            Application Under Review
          </h1>

          <div className="w-12 h-[1px] bg-[#C9A96E] mx-auto mb-6" />

          <p className="text-[#999] text-base leading-relaxed mb-2" style={{ fontFamily: "'Jost', sans-serif" }}>
            Thank you for your interest in the Sàwai Capital Dealroom.
          </p>
          <p className="text-[#999] text-base leading-relaxed mb-8" style={{ fontFamily: "'Jost', sans-serif" }}>
            Your access request is being reviewed by our team. We verify every investor to maintain the exclusivity and quality of our deal network. You will receive access once your application is approved.
          </p>

          {user && (
            <div className="bg-[#FAF8F5]/5 border border-[#A0743A]/15 p-4 mb-8 text-left">
              <p className="text-[#C9A96E] text-xs uppercase tracking-[0.15em] font-semibold mb-2" style={{ fontFamily: "'Jost', sans-serif" }}>Your Details</p>
              <p className="text-[#FAF8F5] text-sm">{user.name}</p>
              <p className="text-[#999] text-sm">{user.email}</p>
              <p className="text-[#A0743A] text-xs mt-2 uppercase tracking-wider font-semibold flex items-center gap-2">
                <Clock size={12} /> Pending Verification
              </p>
            </div>
          )}

          <div className="space-y-3">
            <a
              href="mailto:dealroom@sawaicap.com"
              className="flex items-center justify-center gap-2 border border-[#A0743A] text-[#A0743A] px-8 py-3 text-sm uppercase tracking-[0.15em] font-semibold hover:bg-[#A0743A]/10 transition-colors w-full"
              style={{ fontFamily: "'Jost', sans-serif" }}
              data-testid="contact-email-btn"
            >
              <Mail size={14} /> Contact Us
            </a>

            <button
              onClick={handleLogout}
              className="flex items-center justify-center gap-2 text-[#999] hover:text-[#FAF8F5] transition-colors px-8 py-3 text-sm uppercase tracking-[0.15em] w-full"
              style={{ fontFamily: "'Jost', sans-serif" }}
              data-testid="pending-logout-btn"
            >
              <LogOut size={14} /> Sign Out
            </button>
          </div>
        </div>

        <p className="text-[#555] text-xs mt-8" style={{ fontFamily: "'Jost', sans-serif" }}>
          Typical review time: 1-2 business days
        </p>
      </div>
    </div>
  );
}
